import { Node } from '@/components/diagrams/FlowChart';
import {
  generateTextNoteId,
  TEXT_NOTE_DEFAULT_HEIGHT,
  TEXT_NOTE_DEFAULT_WIDTH,
} from '@/components/diagrams/FlowChart/utils/textNoteUtils';

import { AddTextNoteAction, EntityDiagramActionFn } from '../types';

export const addTextNoteAction: EntityDiagramActionFn<AddTextNoteAction> = (
  state,
  action
) => {
  const newNode: Node = {
    id: generateTextNoteId(),
    type: 'textNote',
    position: action.position,
    width: TEXT_NOTE_DEFAULT_WIDTH,
    height: TEXT_NOTE_DEFAULT_HEIGHT,
    data: {
      notes: '',
    },
  };

  return {
    ...state,
    nodes: [...state.nodes, newNode],
  };
};
